module.exports = __webpack_public_path__ + "static/media/sub-icon.d8c80e29.jpeg";